import DevDemos from "views/devDemos"
import { Routes } from "../routes"

// Intended for playground
const demoRoutes = process.env.NODE_ENV==="development" ? [{
    path: Routes.demos,
    element: <DevDemos />
}]:[]

export default demoRoutes